export default "__VITE_PUBLIC_ASSET__6e575bb6__"